// extracted by mini-css-extract-plugin
export default {"menuArea":"styles_menuArea__rkbmK","labelText":"styles_labelText__AIhhz","icon":"styles_icon__j-z8U"};